(() => {
  if (window.mexoNewsletterDiscountCopyReady) return;
  window.mexoNewsletterDiscountCopyReady = true;

  const copyWithFallback = (text) => {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.top = '-999px';
    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
    } finally {
      input.remove();
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-newsletter-copy-code]');
    if (!(button instanceof HTMLButtonElement)) return;

    const code = button.dataset.newsletterCopyCode || '';
    if (!code) return;

    const copiedLabel = button.dataset.newsletterCopiedLabel || 'Kopiert';
    const originalLabel = button.dataset.newsletterCopyLabel || button.textContent || 'Kopieren';

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        copyWithFallback(code);
      }
    } catch (error) {
      copyWithFallback(code);
    }

    button.textContent = copiedLabel;
    window.setTimeout(() => {
      button.textContent = originalLabel;
    }, 2200);
  });
})();
